<app-header [label]="page_name"></app-header>
<div class="flex bg-white gap-4 items-center justify-end p-4 border-b border-gray-300">
     <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
     <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
</div>
<app-ag-grid-list [list]="items" [colDefs]="transaction_history_cols" [itemName]="page_name" [show_checkboxes]="false" [bulk_delete]="false" (fetch_new_list)="get_list($event)"></app-ag-grid-list>

<app-payment-receipt #receipt_modal></app-payment-receipt>